export default "<p class=\"ion-padding\">\n  {{data | json}}\n</p>\n"